import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PublishedDataType } from 'api/status-updates';
import { DocumentProvider } from 'components/organisms/document/document-store';
import { SquadProvider } from 'contexts/providers/squad';
import { TaskFieldsProvider } from 'contexts/providers/task-fields';
import { TaskPaneContextProvider } from 'contexts/providers/task-pane';
import { selectDocumentResourceSections } from 'data/documents';
import { selectActiveStatusUpdate } from 'data/status-updates';
import { ResourceSectionProps } from '../resource-section-renderer';
import { ResourceListSectionBase } from './resource-section';

export const ResourceListSection: FC<ResourceSectionProps> = ({
  config,
  projectId: _projectId,
}) => {
  const { resourceSectionId, resourceIds, extraContextData } = config;

  const activeStatusUpdate = useSelector(selectActiveStatusUpdate);
  const projectId = useMemo(
    () => _projectId ?? activeStatusUpdate?.project.projectId,
    [_projectId, activeStatusUpdate],
  );

  const documentResources = useSelector(selectDocumentResourceSections);

  const condition =
    extraContextData?.publishedData &&
    extraContextData?.publishedData?.length > 0;

  const sectionResources = !condition
    ? documentResources &&
      documentResources?.find(
        (resource) =>
          Number((resource as PublishedDataType).resourceSectionId) ===
          Number(resourceSectionId),
      )
    : extraContextData?.publishedData &&
      extraContextData?.publishedData?.find(
        (resource) =>
          Number((resource as PublishedDataType).resourceSectionId) ===
          Number(resourceSectionId),
      );

  return projectId && sectionResources && 'resourceIds' in sectionResources ? (
    <TaskPaneContextProvider>
      <DocumentProvider>
        <SquadProvider projectId={projectId}>
          <TaskFieldsProvider>
            <ResourceListSectionBase
              projectId={projectId}
              config={{
                ...config,
                resourceIds: sectionResources.resourceIds // these ResourceIds are the one after user deletes some resource entries.
                  ? sectionResources.resourceIds
                  : [],
                resourceSectionId: Number(resourceSectionId),
                originalResourceIds: resourceIds, // resourceIds from props are the original ids which we used to create the section
              }}
              publishedTasks={
                condition
                  ? (sectionResources?.resourceObjects as any) ?? []
                  : []
              }
            />
          </TaskFieldsProvider>
        </SquadProvider>
      </DocumentProvider>
    </TaskPaneContextProvider>
  ) : null;
};
